import { render, staticRenderFns } from "./AppConfigurationPage.vue?vue&type=template&id=1dd297ce&"
import script from "./AppConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./AppConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports